'use strict';

angular.module('licensure.services')
    .factory('IPTemplates', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/IPTemplates', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getService: function() {
                return get({ service_only: true });
            },

            getVehicle: function () {
                return get({ vehicle_only: true });
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPTemplates/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (template) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPTemplates/';
                if (!isUndefined(template.id)) {
                    method = 'PUT'
                    url += template.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        template: template,
                        result_set: template.result_set
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/IPTemplates/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getDocumentData: function (template_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPTemplates/getDocumentData/' + template_id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });
                return d.promise;
            },

            saveDocumentData: function (template_id, document_id, code) {
                var d = $q.defer();

                $http.put(apiLocation + '/api/IPTemplates/saveDocumentData', {
                    template_id: template_id,
                    document_id: document_id,
                    document_code: code
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            getInspectionLicenseLevelOptions: function (templateId) {
                var d = $q.defer();
                $http.get(apiLocation + '/api/IPTemplates/getInspectionLicenseLevelOptions/' + templateId, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getInspectionLicenseLevels: function (template_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPTemplates/getInspectionLicenseLevels/' + template_id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        };
    }])
;